export default {
  iStoreUrl: 'http://localhost:5001/istore',
  // iStoreSTT: 'https://192.168.1.19/sttqueue',
  iStoreCloud: 'https://rdcloud.starise.network/istore',
  activityCheckInterval: 60000 * 15,
  waterMarkingId: null,
}
